// import { BigNumber } from 'ethers';
import { config } from '../../config/config';
import { EnabledChains } from '../../config/constants';
import post from './post';

type WithURL = {
    url?: string;
    chainId?: never;
};

type WithChainID = {
    url?: never;
    chainId?: EnabledChains[number];
};

type QueryParams = WithURL | WithChainID;

const subgraphQuery = async (query: string, queryParams: QueryParams) => {
    let { chainId, url } = queryParams;

    if (!url && chainId) {
        url = config.endpoints[chainId].unlimitedSubgraph;
    }

    if (!url) {
        console.error('SubgraphQuery: URL is undefined');
        return;
    }

    const subgraphQuery = `
        query Query {
            ${query}
        }
    `;

    const res = await post(url, { query: subgraphQuery });

    return res.data;
};

export default subgraphQuery;
